/**
 * Task ids this browser tab started itself.
 *
 * Background deliverable runs finish long after the dialog that launched them is gone, and the bell
 * shows every run the user owns — including ones started on another machine. Auto-downloading all of
 * them would drop unexpected files into the user's Downloads folder, so only the tab that actually
 * pressed Run downloads automatically; everyone else gets the Download button.
 *
 * Deliberately module state and not Redux or localStorage: it must NOT survive a reload. After a
 * refresh the tab is no longer "the one waiting" — at that point the bell is the interface, and a
 * file materialising out of a page the user just reloaded would be surprising.
 */
const startedInThisTab = new Set<string>();

export const rememberStartedTask = (taskId: string): void => {
  startedInThisTab.add(taskId);
};

/** True if this tab started the task; also forgets it, so the download fires at most once. */
export const consumeStartedTask = (taskId: string): boolean =>
  startedInThisTab.delete(taskId);
